import React, { useMemo, FC, PropsWithChildren } from 'react';

import { useShopConfig } from 'src/explore/hooks/useShopConfig';

import LinkComponent from '../../../../../../atoms/Link';

interface LinkProps {
  className?: string;
}

const Link: FC<PropsWithChildren<LinkProps>> = ({ children, className }) => {
  const config = useShopConfig();

  const accountLink = useMemo(
    () => ( config.rewardsPointsEnabled ? '/rewards?ref=header' : '/account/orders?ref=header' ),
    [ config ]
  );

  return (
    <LinkComponent className={className} href={accountLink}>
      {children}
    </LinkComponent>
  );
};

export default Link;
